export default __webpack_public_path__ + "static/princeton-464a69991c33a73d4b41ae6e91ae9da1.svg";